// extracted by mini-css-extract-plugin
module.exports = {"share":"Share_share__1ZRqU","content":"Share_content__24_zp","shareText":"Share_shareText__2zzMP","buttons":"Share_buttons__2plEX"};